export default __webpack_public_path__ + "static/media/easychek_logo.9bef1126.jpg";